var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tian-di-tu"},[_c('img',{attrs:{"src":require("@/assets/images/tdt-bg.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.textVal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }